import { HealthieTag } from '../../hooks/queries/appointment-by-room-name/types';
import { defaultTagActionRules } from './defaultRules';
import { CallPhase, TagAction, TagActionRule } from './types';

class TagActionEngine {
  private rules: TagActionRule[] = [];

  constructor() {
    // Load default rules
    defaultTagActionRules.forEach((rule) => this.registerRule(rule));
  }

  registerRule(rule: TagActionRule): void {
    this.rules.push(rule);
  }

  getActionsForPhase(phase: CallPhase, tags: HealthieTag[]): TagAction[] {
    const tagNames = tags.map((tag) => tag.name?.toLowerCase());

    const matchingRules = this.rules.filter((rule) => {
      if (rule.phase !== phase) return false;

      const ruleTagNames = rule.tagNames.map((name) => name.toLowerCase());

      if (rule.requireAllTags) {
        // All rule tags must be present
        return ruleTagNames.every((tagName) => tagNames.includes(tagName));
      } else {
        // Any rule tag must be present
        return ruleTagNames.some((tagName) => tagNames.includes(tagName));
      }
    });

    // Collect all actions from matching rules
    return matchingRules.flatMap((rule) => rule.actions);
  }
}

export const tagActionEngine = new TagActionEngine();
